import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './FrequencyButton.styled';
import { Heart } from '../../../svgs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FrequencyButton = _ref => {
  let {
    children,
    doFadeIn,
    isActive,
    handleClick,
    showRecurringNudgeTag = false,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation(['blocks.common']);
  return /*#__PURE__*/_jsxs(Styled.FrequencyButton, {
    doFadeIn: doFadeIn,
    isActive: isActive,
    "aria-current": isActive ? 'true' : 'false',
    type: "button",
    onClick: e => {
      e.preventDefault();
      handleClick();
    },
    ...rest,
    children: [showRecurringNudgeTag && /*#__PURE__*/_jsxs(Styled.FrequencyButtonNudgeTag, {
      children: [t('Frequency.nudgeTag'), " ", /*#__PURE__*/_jsx(Heart, {})]
    }), isActive && /*#__PURE__*/_jsx(Styled.CheckIcon, {}), children]
  });
};